import styled from 'styled-components'

const ContainerSuperLoading = styled.div`
  width: 100vw;
  height: 100vh;

  background-color: var(--primary-color);

  position: fixed;
  top: 0;
  left: 0;

  z-index: 99;
  opacity: 1;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  transition: all 0.4s ease-in-out;

  .header-logo {
    width: 100%;
    height: 100px;

    color: white;

    display: flex;
    align-items: center;
    justify-content: center;

    color: var(--secondary-color);

    font-size: 21px;

    img {
      width: 100px;
      border-radius: 18px;

      margin-bottom: 80px;
      box-shadow: rgba(149, 157, 165, 0.3) 0px 8px 24px;
    }
  }

  .loading-bar {
    width: 200px;
    height: 5px;

    display: flex;

    background-color: #ffffff30;

    .content-loading-bar {
      width: 0px;
      height: 100%;
      background-color: white;
    }
  }
`
export default ContainerSuperLoading
